// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../public/AdminIcons/defaultSideMenuHeadingLine.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBar-sideMenuContent-HZTom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    width: 100%;
}

.SideBar-sideMenuHeader-wJ12K {
    position: relative;
    padding: 24px 32px;
    text-align: center;
    color: var(--sideMenu-primary-foreground);
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 16px;
    grid-gap: 16px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--sideMenu-primary-border);
}

.SideBar-sideMenuHeader-wJ12K::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
            transform: translateX(-50%);
    width: 200px;
    height: 6px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.SideBar-sideMenuBody-GpcgT {
    padding-bottom: 80px;
    height: 100%;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    overflow-y: auto;
}

.SideBar-sideMenuBody-GpcgT::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.SideBar-sideMenuBody-GpcgT::-webkit-scrollbar-thumb {
    background: var(--btn-primary-bg);
    border-radius: calc(var(--radius-1)*2);
}

.SideBar-sideMenuBody-GpcgT::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px var(--primary-border);
            box-shadow: inset 0 0 5px var(--primary-border);
    border-radius: calc(var(--radius-1)*2);
}

@-moz-document url-prefix() {

    /* Support above Firefox 64 (December 2018). */
    .SideBar-sideMenuBody-GpcgT {
        scrollbar-width: thin;
        scrollbar-color: var(--btn-primary-bg) transparent;
    }
}

.SideBar-sideMenuHeaderLogoContainer-P1F_h {
    max-width: 216px;
    height: 60px;
    display: inline-block;
}

.SideBar-sideMenuHeaderLogoContainer-P1F_h img {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.SideBar-sideMenuHeaderLogoText-ndzo9,
.SideBar-sideMenuHeaderLogoText-ndzo9:hover,
.SideBar-sideMenuHeaderLogoText-ndzo9:focus {
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    text-decoration: none;
    white-space: pre-line;
    word-break: break-word;
}

.SideBar-sideMenuHeaderTextContainer-FCiT6 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 8px;
    text-align: start;
}

.SideBar-sideMenuHeaderTextContainer-FCiT6 img {
    position: relative;
    top: 2px;
    width: 22px;
    height: 22px;
    -o-object-fit: contain;
       object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,yDAAqF;IACrF,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,sCAAwC;AAC5C;;AAEA;IACI,uDAA+C;YAA/C,+CAA+C;IAC/C,sCAAwC;AAC5C;;AAEA;;IAEI,8CAA8C;IAC9C;QACI,qBAAqB;QACrB,kDAAkD;IACtD;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB","sourcesContent":[".sideMenuContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.sideMenuHeader {\n    position: relative;\n    padding: 24px 32px;\n    text-align: center;\n    color: var(--sideMenu-primary-foreground);\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    grid-gap: 16px;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n    border-bottom: 1px solid var(--sideMenu-primary-border);\n}\n\n.sideMenuHeader::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 200px;\n    height: 6px;\n    background-image: url('../../../../public/AdminIcons/defaultSideMenuHeadingLine.png');\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n\n.sideMenuBody {\n    padding-bottom: 80px;\n    height: 100%;\n    flex-grow: 1;\n    overflow-y: auto;\n}\n\n.sideMenuBody::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n}\n\n.sideMenuBody::-webkit-scrollbar-thumb {\n    background: var(--btn-primary-bg);\n    border-radius: calc(var(--radius-1) * 2);\n}\n\n.sideMenuBody::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px var(--primary-border);\n    border-radius: calc(var(--radius-1) * 2);\n}\n\n@-moz-document url-prefix() {\n\n    /* Support above Firefox 64 (December 2018). */\n    .sideMenuBody {\n        scrollbar-width: thin;\n        scrollbar-color: var(--btn-primary-bg) transparent;\n    }\n}\n\n.sideMenuHeaderLogoContainer {\n    max-width: 216px;\n    height: 60px;\n    display: inline-block;\n}\n\n.sideMenuHeaderLogoContainer img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.sideMenuHeaderLogoText,\n.sideMenuHeaderLogoText:hover,\n.sideMenuHeaderLogoText:focus {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 28px;\n    text-decoration: none;\n    white-space: pre-line;\n    word-break: break-word;\n}\n\n.sideMenuHeaderTextContainer {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 8px;\n    text-align: start;\n}\n\n.sideMenuHeaderTextContainer img {\n    position: relative;\n    top: 2px;\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuContent": `SideBar-sideMenuContent-HZTom`,
	"sideMenuHeader": `SideBar-sideMenuHeader-wJ12K`,
	"sideMenuBody": `SideBar-sideMenuBody-GpcgT`,
	"sideMenuHeaderLogoContainer": `SideBar-sideMenuHeaderLogoContainer-P1F_h`,
	"sideMenuHeaderLogoText": `SideBar-sideMenuHeaderLogoText-ndzo9`,
	"sideMenuHeaderTextContainer": `SideBar-sideMenuHeaderTextContainer-FCiT6`
};
module.exports = ___CSS_LOADER_EXPORT___;
